var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-csv-mappingscreen',{ref:"csvref",attrs:{"title":"Mapping Screen","db-columns-list":_vm.dbColumnsList},on:{"mappedData":_vm.mappingMethod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }